var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningOutlineItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2659 20.9981H2.73288C2.37562 20.9981 2.04551 20.8075 1.86688 20.4981C1.68825 20.1887 1.68825 19.8075 1.86688 19.4981L11.1329 3.49811C11.3117 3.18923 11.6415 2.99902 11.9984 2.99902C12.3553 2.99902 12.6851 3.18923 12.8639 3.49811L22.1299 19.4981C22.3084 19.8074 22.3085 20.1883 22.1301 20.4977C21.9518 20.807 21.622 20.9977 21.2649 20.9981H21.2659Z",
    fill: "#848FAB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 16,
    width: 2,
    height: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 2,
    height: 5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutlineItem);
export default __webpack_public_path__ + "static/media/warning_outlineItem.c5fa77fa20ca0fe6f8ea4e796eecd137.svg";
export { ForwardRef as ReactComponent };